import { TERMINAL_STATUSES } from './post_approval_plaid';

const BACKOFF_MS = [1000, 2000, 3000, 5000];

export const MAX_CONSECUTIVE_FAILURES = 3;
export const MAX_AWAITING_SERVER_RETRIES = 6;

const errorValue = (error, key) => error && (error.get?.(key) ?? error[key]);

export const shouldAutoRetry = ({
  consecutiveFailures,
  awaitingServerRetries,
  lastError,
}) =>
  !(
    lastError &&
    (errorValue(lastError, 'http_status') === 401 ||
      errorValue(lastError, 'reason_code') === 'unauthorized')
  ) &&
  consecutiveFailures < MAX_CONSECUTIVE_FAILURES &&
  awaitingServerRetries < MAX_AWAITING_SERVER_RETRIES;

const toMilliseconds = (value) => {
  if (value instanceof Date) {
    return value.getTime();
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  return null;
};

const currentMilliseconds = (value) => {
  const milliseconds = toMilliseconds(value);
  return milliseconds === null ? Date.now() : milliseconds;
};

const hasPassedDeadline = (deadlineAt, now) => {
  const deadlineMs = toMilliseconds(deadlineAt);
  const nowMs = currentMilliseconds(now);

  return deadlineMs !== null && nowMs >= deadlineMs;
};

export const nextDelayMs = ({ attemptNumber = 1, deadlineAt, now } = {}) => {
  const normalizedAttempt = Number.isFinite(Number(attemptNumber))
    ? Math.max(1, Math.ceil(Number(attemptNumber)))
    : 1;
  const backoff =
    BACKOFF_MS[Math.min(normalizedAttempt - 1, BACKOFF_MS.length - 1)];
  const deadlineMs = toMilliseconds(deadlineAt);

  if (deadlineMs === null) {
    return backoff;
  }

  const nowMs = currentMilliseconds(now);
  return Math.max(0, Math.min(backoff, deadlineMs - nowMs));
};

export const shouldContinue = (status) => status === 'processing';

export const phase = ({ status, deadlineAt, now } = {}) => {
  if (TERMINAL_STATUSES.includes(status)) {
    return 'terminal';
  }

  if (hasPassedDeadline(deadlineAt, now)) {
    return 'awaiting_server';
  }

  return 'polling';
};
